<template>
  <div class="app-search-dates">

    <input-title :required="options.required" :description="options.description"/>

    <div class="input-groups">

      <div
        v-for="(_, i) in valueLocal"
        :key="`input-group-${i}`"
        class="input-group">

        <el-date-picker
          v-model="valueLocal[i]"
          :key="'input-' + i"
          v-bind="widgetOptions"
          :ref="`input${i}`"
          type="daterange"
          format="dd.MM.yyyy"
          value-format="yyyy-MM-dd"
          align="right"
          unlink-panels
          range-separator="по"
          start-placeholder="Начало"
          end-placeholder="Конец"
          style="width: 100%"
          :picker-options="pickerOptions"/>

      </div>

    </div>

    <add-rem-btns/>

  </div>
</template>

<script>
import Common from './mixins/Common';

export default {

  mixins: [Common],

  data() {
    return {
      valueBase: '',
      pickerOptions: {
        shortcuts: [{
          text: 'За неделю',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (3600 * 1000 * 24 * 7));
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: 'За месяц',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (3600 * 1000 * 24 * 30));
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: 'За 3 месяца',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (3600 * 1000 * 24 * 90));
            picker.$emit('pick', [start, end]);
          },
        }],
      },
    };
  },

  mounted() {
    // Process custom local options of this widget type
    if (this.options) {
      if (this.options.placeholder) {
        this.widgetOptions.placeholder = this.options.placeholder;
      }
    }
  },

};
</script>



// WEBPACK FOOTER //
// src/components/inputs/widgets/AppSearchDates.vue